/** Convenient funtion to set the action payload to the state
 * IMPORTANT! It's impure! Only works with APIs in @reduxjs/toolkit!
 */
export const mergePayload =
  (key) =>
  (state, { payload }) => {
    state[key] = payload;
  };
